/**
 * KEEP IT DUMB AND SIMPLE
 */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { setIsLoading, storeResult } from './actionCreators';
import { reduxKey } from './constants';
const actionHandlers = handleActions({
    [setIsLoading.toString()]: (state, { payload: endpoint })=>_object_spread_props(_object_spread({}, state), {
            loadingEndpoints: [
                ...state.loadingEndpoints,
                endpoint
            ]
        }),
    [storeResult.toString()]: (state, { payload: { endpoint, result } })=>_object_spread_props(_object_spread({}, state), {
            loadingEndpoints: state.loadingEndpoints.filter((e)=>e !== endpoint),
            results: _object_spread_props(_object_spread({}, state.results), {
                [endpoint]: result
            })
        })
}, {
    loadingEndpoints: [],
    results: {}
});
const reducers = {
    [reduxKey]: actionHandlers
};
export default reducers;
